import { useDefaultSubscription } from 'common/services/useDefaultSubscription'

const defaultAddress = '66 Paul Street\nLondon, EC2A 4NA'
export default function () {
  const { subscriptionDetail } = useDefaultSubscription()
  if (!subscriptionDetail) {
    return ''
  }
  const { location } = subscriptionDetail
  if (location) {
    return `${[location.address_line_1, location.address_line_2 || '']
      .filter((v) => !!v)
      .join(', ')}, \n${location.city}, ${location.postal_code}`
  }
  return defaultAddress
}
